// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"36":"MarketTrendsPage.loadable","161":"PriceMyRentalResultsPage.loadable"}[chunkId] || chunkId) + "." + {"36":"d97ade48","161":"8ba8292b","355":"6f2e146e","914":"8b0e96cf"}[chunkId] + ".js";
};